'use client'

import { atom } from 'jotai'

/** Whether the login dialog is open */
export const loginDialogOpenAtom = atom<boolean>(false)

/** Whether the onboarding dialog is open */
const onboardingDialogOpenAtom = atom<boolean>(false)

type Mode = 'login' | 'wallets'
/** Whether the onboarding dialog mode is wallets or login */
const onboardingDialogModeAtom = atom<Mode>('login')

/** Combined state atom for the onboarding dialog */
export const onboardingDialogAtom = atom(
  (get) => ({
    open: get(onboardingDialogOpenAtom),
    mode: get(onboardingDialogModeAtom),
  }),
  (_get, set, update: { open: boolean; mode?: Mode }) => {
    set(onboardingDialogOpenAtom, update.open)
    if (update.mode) {
      set(onboardingDialogModeAtom, update.mode)
    }
  },
)

/** Helper functions for common onboarding dialog actions */
export const openOnboardingDialog = (mode: Mode = 'login') => ({
  open: true,
  mode,
})

export const closeOnboardingDialog = () => ({
  open: false,
})
